import React, { useEffect, useState } from 'react';

import { features } from 'components/lexemes';
import { CdnImagePath } from 'lib/cdn-image-path';
import useMediaQuery, { MediaQueryWidth } from 'lib/use-media-query';

import PageSectionAboutHero from 'components/page/sections/page-section-about-hero';

export const ComplimentsHeroBlockContainer: React.FC = () => {
    const isMobile = useMediaQuery(MediaQueryWidth['desktop-sm']);

    const [imageUrl, setImageUrl] = useState(
        `${CdnImagePath}/landing/assets/photos/features/compliments/compliments-hero-landscape.jpg`,
    );

    useEffect(() => {
        if (isMobile) {
            setImageUrl(
                `${CdnImagePath}/landing/assets/photos/features/compliments/compliments-hero-portrait.jpg`,
            );
        } else {
            setImageUrl(
                `${CdnImagePath}/landing/assets/photos/features/compliments/compliments-hero-landscape.jpg`,
            );
        }
    }, [isMobile]);

    const props = {
        title: features.compliments.lxComplimentsHeroTitle,
        imageSrc: imageUrl,
        objectPosition: '50% 33%',
        subTitle: features.compliments.lxComplimentsHeroSubtitle,
    };

    return (
        <PageSectionAboutHero
            image={{
                src: props.imageSrc,
                objectPosition: props.objectPosition,
                hasLoadPriority: true,
            }}
            title={props.title}
            subtitle={props.subTitle}
            color="peach"
        />
    );
};
